import SpriteSymbol from "../../../../mobile/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-star-stroked",
  "use": "svg-icon-star-stroked-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" id=\"svg-icon-star-stroked\"><path d=\"M6 8.3L3.3 9.7l.5-3-2.2-2.1 3-.4L6 1.5l1.4 2.7 3 .4-2.2 2.1.5 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol